module.exports = __webpack_public_path__ + "static/media/anpost.b4e82fd2.png";